import { Col, Row } from 'antd'
import { useFormState } from 'react-final-form'
import { useTranslation } from 'react-i18next'

import { Divider } from 'App/components'

import { TextFieldSkeleton } from '../../../../components'
import { TOrganizerSettingsFormValues } from '../OrganizerSettings'
import { UnityHubSettingsTitle } from '../../../../components/UnityHub/UnityHubSettings/UnityHubSettingsTitle'
import { UnityHubSettingsDescription } from '../../../../components/UnityHub/UnityHubSettings/UnityHubSettingsDescription'

import { OrganizerPlacementItem } from './OrganizerPlacementItem'
import styles from './OrganizerPlacement.module.scss'

export type TOrganizerPlacementProps = {
  loading: boolean
}

export const OrganizerPlacement = ({ loading }: TOrganizerPlacementProps) => {
  const { values } = useFormState<TOrganizerSettingsFormValues>()

  const { t } = useTranslation()

  return (
    <>
      <Col xs={24}>
        <Row gutter={[0, 12]}>
          <Col xs={24}>
            <UnityHubSettingsTitle title={t('events.organizerSettings.promoteEventTitle')} />
          </Col>
          <Col xs={24}>
            <UnityHubSettingsDescription
              description={t('events.organizerSettings.promoteEventDescription')}
            />
          </Col>
          <Row className={styles.headerRow}>
            <Col xs={8}>
              <b>{t('events.organizerSettings.promoteEventWhereColumn')}</b>
            </Col>
            <Col xs={8}>
              <b>{t('events.organizerSettings.promoteEventVisibleSwitch')}</b>
            </Col>
            <Col xs={8}>
              <b>{t('events.organizerSettings.promoteEventJoinableSwitch')}</b>
            </Col>
          </Row>
          <TextFieldSkeleton loading={loading}>
            {values.placementOrganizations.map((_, index) => {
              const name = `placementOrganizations[${index}]`

              return (
                <OrganizerPlacementItem key={`${name}-event`} name={name} type="organization" />
              )
            })}
          </TextFieldSkeleton>
          <TextFieldSkeleton loading={loading}>
            {values.placementCommunities.map((_, index) => {
              const name = `placementCommunities[${index}]`

              return <OrganizerPlacementItem key={`${name}-event`} name={name} type="community" />
            })}
          </TextFieldSkeleton>
        </Row>
      </Col>

      <Divider />

      <Col xs={24}>
        <Row gutter={[0, 12]}>
          <Col xs={24}>
            <UnityHubSettingsTitle title={t('events.organizerSettings.promoteCommunityTitle')} />
          </Col>
          <Col xs={24}>
            <UnityHubSettingsDescription
              description={t('events.organizerSettings.promoteCommunityDescription')}
            />
          </Col>
          <Row className={styles.headerRow}>
            <Col xs={8}>
              <b>{t('events.organizerSettings.promoteEventWhereColumn')}</b>
            </Col>
            <Col xs={8}>
              <b>{t('events.organizerSettings.promoteEventVisibleSwitch')}</b>
            </Col>
            <Col xs={8}>
              <b>{t('events.organizerSettings.promoteEventJoinableSwitch')}</b>
            </Col>
          </Row>
          <TextFieldSkeleton loading={loading}>
            {values.placementCommunities.map((_, index) => {
              const name = `placementCommunities[${index}]`

              return (
                <OrganizerPlacementItem
                  key={`${name}-community`}
                  name={name}
                  type="community"
                  promoteSection="community"
                />
              )
            })}
          </TextFieldSkeleton>
        </Row>
      </Col>
    </>
  )
}
